import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'how-to-split-pdf-dialog',
    templateUrl: './how-to-split-pdf-dialog.component.html',
    styleUrls: ['./how-to-split-pdf-dialog.component.scss'],
    standalone: false
})
export class HowToSplitPdfDialogComponent {

    constructor(
    public dialogRef: MatDialogRef<HowToSplitPdfDialogComponent>
    ) { }

}
